/**
 * Runtime gate for browser performance tracing. Error capture is not gated.
 *
 * Sentry.init runs once at module load, before the consent context exists, so
 * the gate is a module-level flag that the SDK hooks read on every call and
 * CookieConsentProvider updates when analytics consent changes.
 */

const SAMPLE_RATE = 0.01;

let tracingAllowed = false;

export function setTracingConsent(allowed: boolean): void {
  tracingAllowed = allowed;
}

/** Sampling decision for new transactions: 0 until analytics is accepted. */
export function tracesSampler(): number {
  return tracingAllowed ? SAMPLE_RATE : 0;
}

/** Drops any transaction that finishes while tracing is not allowed. */
export function gateTransaction<T>(event: T): T | null {
  return tracingAllowed ? event : null;
}
